import { render, staticRenderFns } from "./IntegraYouse.vue?vue&type=template&id=2b588c63"
import script from "./IntegraYouse.vue?vue&type=script&lang=js"
export * from "./IntegraYouse.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports